import React, { useMemo } from 'react';
import _isArray from 'lodash/isArray';
import styles from './index.module.scss';
import { DropOffLocations } from '@return-rabbit/nexus';

const getDropffLocationsDescriptions = (isUPS = false) => {
  const codeType = isUPS ? 'barcode' : 'QR code';
  return {
    qr_code: `Show the ${codeType} on your mobile device to the nearest supported location they will print the shipping label for you.`,
    no_box_no_label:
      "Show the barcode and unpackaged items at a supported The UPS Store®. They'll handle packing and labeling."
  };
};

export default function NextSteps({
  list = [],
  osId = '',
  zipcode = '',
  isUPS = false,
  labelType = ''
}) {
  const [modalId, setModalId] = React.useState(null);
  const handleModalClick = action => {
    if (action === 'dropoffLocations') {
      setModalId('dropoffLocations');
    }
  };

  const renderSegment = (segment, segmentIndex) => {
    const { text, action, linkUrl } = segment;

    // Handle segments with actions
    if (action && action !== 'link') {
      return (
        <button
          key={segmentIndex}
          type="button"
          onClick={() => handleModalClick(action)}
          aria-label={action}
        >
          {text}
        </button>
      );
    }

    if (action === 'link' && linkUrl) {
      return (
        <a
          key={segmentIndex}
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </a>
      );
    }

    // Plain text segment
    return <span key={segmentIndex}>{text}</span>;
  };

  const steps = useMemo(() => {
    if (!_isArray(list)) return null;
    return list.map((item, index) => {
      return (
        <div key={index} className={styles.item}>
          <span className={styles.index}>{index + 1}</span>
          <p className={styles.text}>
            {item.map((segment, segmentIndex) =>
              renderSegment(segment, segmentIndex)
            )}
          </p>
        </div>
      );
    });
  }, [list]);

  const description = useMemo(() => {
    if (modalId !== 'dropoffLocations') return null;
    const descriptions = getDropffLocationsDescriptions(isUPS);
    return descriptions[labelType] || '';
  }, [modalId, isUPS, labelType]);

  if (!steps) return null;
  return (
    <>
      <div className={styles.container}>{steps}</div>
      <DropOffLocations.Modal
        isOpen={modalId === 'dropoffLocations'}
        onClose={() => setModalId(null)}
        osId={osId}
        description={description}
        defaultZipCode={zipcode}
        className={styles.dropoffLocations}
      />
    </>
  );
}
